import { jsx as t, Fragment as h } from "@emotion/react/jsx-runtime";
import { PRODUCT_ICONS_V2 as e } from "./Icons.js";
import { StyledIcon as p } from "./ProductButton.styled.js";
import { DEFAULT_PRODUCT_ICON_SIZE_V2 as r } from "../../types/components/productIconsV2.js";
const _ = ({
  name: o,
  isHovered: i,
  active: m = !1,
  disabled: l = !1,
  color: n = "white",
  activeColor: f = "primary"
}) => /* @__PURE__ */ t(p, { disabled: l, color: n, activeColor: f, active: m, width: r, height: r, viewBox: `0 0 ${r} ${r}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ t(h, { children: i ? e?.[o].hover : e?.[o].default }) });
export {
  _ as ProductIconV2
};
